import { useContext } from "react";
import { ItemsSelectionContext } from "./ItemsSelectionProvider";

export const useSelection = () => useContext(ItemsSelectionContext);
